import { TableColumnsType } from "antd";
import { UserProfileRateDomain } from "../../models/commonModels";

export const columns: TableColumnsType<UserProfileRateDomain> = [
  {
    title: 'Дата',
    dataIndex: 'date',
  },
  {
    title: 'Дистанция',
    dataIndex: 'distance',
        render(text,record){
        return {
            props:{

            },
            children:<div style={{textAlign:"center", fontSize:"14px"}}>{text}</div>
        }
    }
   
  },
  {
    title: 'Время',
    dataIndex: 'time',
    render(text,record){
        return {
            props:{

            },
            children:<div style={{textAlign:"center", fontSize:"14px"}}>{text}</div>
        }
    }
  },
];